import { Component } from '@angular/core';

import { BaseFormInput } from '../base-form-input';
import { TINYMCE_INIT } from '../../tinymce/tinymce-init';

@Component({
    selector: 'nuso-wysiwyg-input',
    templateUrl: './wysiwyg-input.component.html',
    styleUrls: ['./wysiwyg-input.component.scss'],
    standalone: false
})
export class WysiwygInputComponent extends BaseFormInput {
  readonly tinymceInit = TINYMCE_INIT;
}
